module.exports = __webpack_public_path__ + "static/img/MALAKAI-CHAMPION.a82f1a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MALAKAI-CHAMPION.jpg
// module id = z+7s
// module chunks = 0